'use client';

import {
  FAVORITES_SORTS,
  type FavoritesSort as Sort,
} from '@eliadmin/core/src/components/nt/account/favorites/favorites-data';
import { SortMenu } from '@eliadmin/core/src/components/nt/category/listing/listing-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma „Sort“ of the favourites (208:12397): „Zoradiť:“ in Body/M #363D36, the current order in
 * Body/M Bold #0D110D and the 16 px caret, gap 6; a radio menu like the category sort. The labels
 * are the admin options in the order of `FAVORITES_SORTS`.
 */
export function FavoritesSort({
  labels,
  value,
  onChange,
  className,
}: {
  /** „Naposledy pridané | Najlacnejšie | Najdrahšie“ split. */
  labels: string[];
  value: Sort;
  onChange: (sort: Sort) => void;
  className?: string;
}) {
  const { t } = useTranslations();
  const options = FAVORITES_SORTS.slice(0, labels.length).map((sort, index) => ({
    value: sort,
    label: labels[index],
  }));
  return (
    <SortMenu
      label={`${t('text2302')}:`}
      value={value}
      options={options}
      onChange={onChange}
      className={cn('gap-1.5', className)}
      valueClassName="nt-body-m-bold"
    />
  );
}
